<script>
 export let value
 import {StarRating} from '../../widgets/';
</script>
<StarRating editable="{false}" size="{14}" {value}/>
